export default __webpack_public_path__ + "static/media/sushiswap.5971858b.svg";